<template>
  <div class="row">
    <div class="col-md-12">
      <div class="category-top-bar">
        <div class="top-bar">
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </div>
      </div>
      <p class="clearfix"></p>
      <subscription-form :route="route"></subscription-form>
    </div>
  </div>
</template>
<script>
  import SubscriptionForm from './SubscriptionForm.vue'
  // used for both /marketing/subscriptions/add and /marketing/subscriptions/edit/:id
  export default {
    components: {
      SubscriptionForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Subscriptions/SubscriptionPage.vue